import { lowerCase } from 'lodash';

export const presenceText = {
  clockInText: 'Absen Masuk',
};

export const headText = {
  handleWelcomingText: ({ userName, t }) => `${t('headTitle')}, ${userName}`,
};

export const clockInText = {
  clockOutText: 'Clock out',
  mealBreakText: 'Istirahat Makan',
  mealText: 'Makan',
  prayBreakText: 'Istirahat Sholat',
  prayText: 'Sholat',
  toiletBreakText: 'Istirahat ke Toilet',
  toiletText: 'Toilet',
  helpPartnerText: 'Bantu Rekan',
  hourPerSessionText: 'menit / sesi',
  remainingText: 'sisa',
  minuteText: 'menit',
};

export const faceTrackingText = {
  accessDeniedTitleText: 'Akses kamera ditolak',
  accessDeniedDescText: `
  <p style="font-size:14px; color: var(--color-semantic-text)">Untuk melanjutkan, izinkan akses kamera dengan cara klik ikon gembok atau kamera di kiri alamat (URL) browser lalu pilih Izinkan kamera. </p> <br/>

  <p style="font-size:14px; color: var(--color-semantic-text)">atau, buka Settings > Privacy & Security > Site Settings > Camera, cari situs Siglive, lalu ubah izin menjadi Allow </p> <br/>

  <p style="font-size:14px; color: var(--color-semantic-text);"> Setelah itu, muat ulang halaman untuk melanjutkan. </p>
  `,
  deviceNotFoundTitleText: 'Kamera tidak ditemukan',
  deviceNotFoundDescText: 'Pastikan perangkat kamera terhubung dan coba lagi.',
};

export const violationModalText = {
  faceRecognizeText: 'Wajah Tidak Terdeteksi',
  willGetViolationInText: 'anda akan mendapat pelanggaran dalam',
  violationNotesAfter60Second: 'Pelanggaran akan tercatat setiap 60 detik. Segera kembali bekerja!',
};

export const presenceModalText = {
  ensureFaceVisibleText: 'Pastikan Wajah Terlihat dengan Jelas',
  faceNotDetectedText: 'Wajah Anda Tidak Terdeteksi Pastikan kamera menyala dan wajah terlihat jelas.',
};

export const changeDeviceModalText = {
  cancelLoginText: 'Batal Login',
  submitChangeDeviceText: 'Ya, lanjut disini',
  continueWorkPromptText: 'Apakah Anda ingin melanjutkan pekerjaan pada perangkat ini?',
};

export const dailyLogText = {
  title: 'Log Hari Ini',
  seeOthers: 'lihat lainnya',
  emptyTitle: 'Belum Ada Data!',
  emptyDescription: 'data akan ditampilkan jika sudah tersedia.',
};

export const activeOperatorsText = {
  title: 'Rekan Aktif Saat Ini',
  emptyTitle: 'Belum Aktif',
  emptyDescription: 'Saat ini rekan - rekan kamu belum aktif',
};

export const breakTooltip = {
  mealBreakTooltipText: ({ t }) => {
    const today = new Date();
    const isFriday = today.getDay() === 5;
    const duration = isFriday ? '90 menit' : '60 menit';
    return t('clock_in_view.mealBreakTooltipText', { duration });
  },
  prayBreakTooltipText: 'Kamu bisa mengambil istirahat sholat sebanyak 2 kali, dengan durasi maksimal 15 menit untuk setiap sesi sholat.',
  toiletBreakTooltipText: `<p> Kamu bisa ke toilet maksimal 3 kali, dengan total durasi tidak lebih dari 15 menit. Contoh:</p>
    <ul>
      <li>•  3 kali, masing-masing 5 menitt</li>
      <li>•  2 kali, per sesi 8 menit dan 7 menit</li>
      <li>•  1 kali selama 15 menit</li>
    </ul>`,
  helpPartnerBreakTooltipText: 'Gunakan fitur Bantu Rekan untuk melakukan pekerjaanmu seperti membantu host atau operator lain yang membutuhkan bantuan.',
  helpPartnerBreakThresholdTooltipText: 'Batas normal durasi Bantu Rekan adalah 30 menit.',
};

export const monitoringHookText = {
  helpPartnerModalTitleText: 'Bantu Rekan sekarang?',
  breakModalTitleText: 'Istirahat sekarang?',
  helpPartnerModalDescText: 'Lanjutkan jika kamu yakin ingin bantu rekan sekarang',
  getDefaultBreakModalDescText: (breakDetail) => `lakukan ${lowerCase(breakDetail?.name)} dalam waktu ${breakDetail?.totalDuration} menit`,
  getRemainingBreakModalDescText: (breakDetail) => `lakukan ${lowerCase(breakDetail?.name)} dalam waktu ${breakDetail?.remainingDuration} menit`,
  secondaryBreakModalButtonText: 'Batal',
  primaryBreakModalButtonText: 'Ya, Lanjut',

  clockOutTitleText: 'Clock out sekarang?',
  clockOutDescText: 'Pastikan pekerjaanmu sudah selesai sebelum melanjutkan untuk clock out',
  clockOutViolationTitleText: 'Belum waktunya Clock Out',
  getClockOutViolationDescText: (endClockOutTime) =>
    `Shift kamu seharusnya selesai pukul ${endClockOutTime}. Kamu akan tercatat melakukan pelanggaran jika kamu clock out sekarang.`,
};

export const breakModalText = {
  helpPartnerButtonText: 'Selesai Bantu Rekan',
  defaultButtonText: 'Selesai Istirahat',
  timeUpText: 'Waktu istirahat habis, ayo segera bekerja!',
  helpPartnerViolationText: 'Mencapai batas waktu normal',
};

export const reasonModalText = {
  textAreaPlaceholder: 'Masukkan Alasan Bantu Rekan',
  textAreaLabel: 'Alasan Bantu Rekan',
  titleText: 'Bantu Rekan',
  buttonText: 'Kirim',
  descriptionText: 'Minimal 20 karakter dan berisi teks yang valid',
  errorText: 'Minimal 20 karakter',
  errorNotValidText: 'Masukkan teks yang valid',
};

export const captchaText = {
  titleText: 'Konfirmasi Kehadiran',
  descriptionText: 'Silakan selesaikan tugas singkat berikut dalam 2 menit.',
  placeholderAnswerInputText: 'Masukkan jawaban Anda',
  sendButtonText: 'Kirim',
  successTitleText: 'Konfirmasi Kehadiran Berhasil',
  successDescriptionText: 'Silahkan lanjutkan pekerjaan kamu!',
  violationTitleText: 'Telat Verifikasi Kehadiran',
  violationDescriptionText: 'Tugas verifikasi kehadiran tidak diselesaikan sesuai waktu yang ditentukan dan tercatat sebagai pelanggaran.',
  wrongCaptchaText: 'Jawaban kamu salah!',
};
